import { Link } from "react-router-dom";

const BlogCard = ({
  href = "#",
  title,
  content,
  author,
  date,
  imageSrc,
  className = "",
  isFrequentQuestion = false,
}) => {
  return (
    <Link
      to={isFrequentQuestion ? "#" : href}
      className={[
        "h-full flex flex-col overflow-hidden rounded-2xl bg-white shadow-md ring-1 ring-black/5",
        "transition-shadow hover:shadow-lg",
        className,
      ].join(" ")}
    >
      {/* Image */}
      <div className="relative">
        {imageSrc ? (
          <img
            src={imageSrc}
            alt={title}
            className="h-44 w-full object-cover sm:h-52"
            loading="lazy"
          />
        ) : (
          <div className="h-44 w-full sm:h-52 bg-slate-200" />
        )}
      </div>

      {/* Body */}
      <div className="flex flex-1 flex-col p-5 text-slate-800">
        <h3
          className={[
            "text-[17px] font-semibold leading-snug",
            "line-clamp-2",
            "[--title-lh:1.375rem] [--title-lines:2]",
            "min-h-[calc(var(--title-lh)*var(--title-lines))]",
          ].join(" ")}
          style={{
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            display: "-webkit-box",
            overflow: "hidden",
          }}
          title={title}
        >
          {title}
        </h3>

        <p
          className={[
            "mt-2 text-sm text-slate-600 leading-6",
            "line-clamp-3",
            "[--body-lh:1.5rem] [--body-lines:3]",
            "min-h-[calc(var(--body-lh)*var(--body-lines))]",
          ].join(" ")}
          style={{
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            display: "-webkit-box",
            overflow: "hidden",
          }}
          title={content}
        >
          {content}
        </p>

        <div className="mt-auto pt-4 flex items-center justify-between text-sm text-slate-500">
          <span className="truncate">{author}</span>
          <time className="shrink-0">{date}</time>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
